import React, { useEffect, useState, useCallback } from "react";
import toast from "react-hot-toast";
import Backend from "../../Backend/Backend";

const fmt = require("indian-number-format");
const backend = await new Backend().init();

export default function EditOptions({ user_id }) {
  const [loading, setLoading] = useState(false);
  const [profitLoss, setProfitLoss] = useState(0);

  const loadProfitLoss = useCallback(async () => {
    if (!user_id) return;

    setLoading(true);

    try {
      const data = {
        server: localStorage.getItem("server"),
        id: localStorage.getItem("id"),
        username: localStorage.getItem("username"),
        token: localStorage.getItem("token"),
        isSuperModal : 1,
        user_id,
      };

      const res = await backend.profit_loss_super(data);
      setLoading(false);

      if (res.error === "False") {
        setProfitLoss(res.profit_loss ?? 0);
      } else {
        toast.error(res.message || "Unable to load profit/loss");
      }
    } catch (err) {
      setLoading(false);
      toast.error("Network error. Try again.");
    }
  }, [user_id]);

  useEffect(() => {
    loadProfitLoss();
  }, [loadProfitLoss]);

  return (
    <div className="NavSubContainer footer hover">
      <div className="NavSubLeft"></div>

      <div className="NavSubRight">
        <div className="text large flex items-center gap-2 mx-2 px-3 py-1 rounded">
          <span className="text-[var(--text)]" >BOOKED :</span>

          <span
            className={`${profitLoss >= 0 ? "buytext" : "selltext"}`}
          >
            {fmt.format(profitLoss || 0)}
          </span>

          {loading && <span className="text-xs text-[var(--text)] opacity-60 ml-2">loading...</span>}
        </div>
      </div>
    </div>
  );
}
